// Stable per-browser identifier + UA parsing.
// Runs client-only. Never sent to third parties.

const STORAGE_KEY = "lumvio_device_id";

export function getOrCreateDeviceId(): string {
  if (typeof window === "undefined") return "";
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing && existing.length >= 8) return existing;
    const fresh =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : `dev_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
    window.localStorage.setItem(STORAGE_KEY, fresh);
    return fresh;
  } catch {
    return `dev_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
  }
}

export function currentDeviceId(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function parseDeviceInfo(ua?: string): { name: string; browser: string; os: string } {
  const a = (ua ?? (typeof navigator !== "undefined" ? navigator.userAgent : "")) || "";
  let browser = "Browser";
  if (/Edg\//.test(a)) browser = "Edge";
  else if (/OPR|Opera/.test(a)) browser = "Opera";
  else if (/Chrome\//.test(a) && !/Edg|OPR/.test(a)) browser = "Chrome";
  else if (/Firefox\//.test(a)) browser = "Firefox";
  else if (/Safari\//.test(a) && !/Chrome|Chromium|Android/.test(a)) browser = "Safari";
  else if (/Chromium/.test(a)) browser = "Chromium";

  let os = "Unknown";
  if (/Windows NT/.test(a)) os = "Windows";
  else if (/Mac OS X|Macintosh/.test(a) && !/iPhone|iPad/.test(a)) os = "macOS";
  else if (/Android/.test(a)) os = "Android";
  else if (/iPhone/.test(a)) os = "iPhone";
  else if (/iPad/.test(a)) os = "iPad";
  else if (/Linux/.test(a)) os = "Linux";
  else if (/CrOS/.test(a)) os = "ChromeOS";

  return { browser, os, name: `${browser} on ${os}` };
}
